<ng-container *ngIf="product$ | async as product">
  <div class="default-padding">
    <app-product-header class="header-detail default-padding margin--top-xxxl" [product]="product"></app-product-header>

    <app-product-article-list
      id="articleListScrollTarget"
      class="block tabs js-tabs default-padding no-overflow"
      [product]="product"
      [articles]="$any(articles$ | async)"
      [facets]="facets$ | async"
      [totalHits]="totalHits$ | async"
    ></app-product-article-list>
  </div>
</ng-container>
